<template>
  <v-card flat class="pl-0" style="max-height: 200px; overflow: auto">
    <v-layout rows class="pl-0">
      <v-navigation-drawer
        class="custom-drawer"
        :mini-variant="drawer.mini"
        mini-variant-width="120"
        mobile-break-point="1"
        v-model="drawer.open"
        floating>

        <v-list dense>
          <v-list-tile class="cursor-pointer"
                       @click="drawer.mini = false">
            <v-list-tile-action>
              <img class="align-center" height="20" src="/static/ltn-l.png"/>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('site-title') }} Profile</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider></v-divider>

          <v-list-tile v-if="isStockyard"
                       @click="toggleProfileData('showLoadChuteInfo')"
                       class="cursor-pointer ">
            <v-list-tile-action><v-icon>directions</v-icon></v-list-tile-action>
            <v-list-tile-content>{{ $t('company-profile.load-chute')}}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="toggleProfileData('showLoadContactInfo')"
                       v-if="company"
                       class="cursor-pointer hidden-sm-and-down">
            <v-list-tile-action><v-icon>account_box</v-icon></v-list-tile-action>
            <v-list-tile-content>Load Contacts</v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="toggleProfileData('showCompanyContactInfo')"
                       v-if="viewProfile"
                       class="cursor-pointer ">
            <v-list-tile-action><v-icon>store</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Company Contact</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="canViewCarrierDocumentation"
                       @click="toggleProfileData('showCarrierDocumentation')"
                       class="cursor-pointer hidden-sm-and-down">
            <v-list-tile-action><v-icon>attach_file</v-icon></v-list-tile-action>
            <v-list-tile-content>Documentation</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>

      <v-layout>
        <v-layout column v-if="showCompanyContactInfo">
          <v-flex >
            <b>Email:</b> {{_.get(viewProfile, 'contactEmail', 'not provided')}}
          </v-flex>
          <v-flex>
            <b>Phone:</b> {{_.get(viewProfile, 'contactPhone', 'not provided')}}
          </v-flex >
          <v-flex >
            <b>Contact Name:</b> {{_.get(viewProfile, 'contactName', 'not provided')}}
          </v-flex>
          <v-flex>
            <b>Billing Address:</b>
            <template v-if="_.get(viewProfile, 'producerInfo.billingAddress', false)">
              <div>{{_.get(viewProfile, 'producerInfo.billingAddress.street1', '')}}</div>
              <div v-if="_.get(viewProfile, 'producerInfo.street2', false)">
                {{_.get(viewProfile, 'producerInfo.billingAddress.street2', '')}}
              </div>
              <div>
                {{_.get(viewProfile, 'producerInfo.billingAddress.city', '')}}
                {{_.get(viewProfile, 'producerInfo.billingAddress.region', '')}}
                {{_.get(viewProfile, 'producerInfo.billingAddress.postalCode', '')}}
              </div>
            </template>
            <span v-else>not provided</span>
          </v-flex>
        </v-layout>
        <v-layout column v-if="showLoadContactInfo && company">
          <v-flex :key="cInx" v-for="(contact, cInx) in company.contacts">
              <label>{{contact.name}}</label> <br>
              <v-icon>local_phone</v-icon>
              <span v-if="contact.phone">{{contact.phone}}</span>
              <span v-else>Missing</span>

              <v-template v-if="contact.nightContactName">
                  <label>{{contact.nightContactName}}</label>
                  <span v-if="contact.nightContactPhone">{{contact.nightContactPhone}}</span>
                  <span v-else>Missing</span>
              </v-template>
          </v-flex>
          <v-flex v-if="isStockyard">
             <label> <v-icon>local_phone</v-icon> {{loadingChute.label}}</label> <br>
             <label><b>Day time:</b></label> <span>{{loadingChute.daytimePhone}}</span> <br>
             <label><b>Night time:</b></label> <span>{{loadingChute.nightTimePhone}}</span>
          </v-flex>
        </v-layout>
        <v-layout column v-if="shouldShowCarrierDocumentation">
          <v-flex>
            <v-flex>
              <b>{{$t('company-profile.vendor-tax-document')}}:</b>
              <v-btn flat v-if="truckingInfo.w9Url" class="pl-0"
                     @click.prevent="openFile(truckingInfo.w9Url)">
                    {{$t('company-profile.vendor-tax-document').toLocaleLowerCase()}}.pdf
              </v-btn>
              <span v-else>Missing</span>
            </v-flex>
            <v-flex>
              <b>Insurance Policy:</b>
              <v-btn flat v-if="truckingInfo.insurancePolicyUrl" class="pl-0"
                     @click.prevent="openFile(truckingInfo.insurancePolicyUrl)">
                Insurance Policy.pdf
              </v-btn>
              <span v-else>Missing</span>
            </v-flex>
          </v-flex>
          <v-flex md6 lg6 xs6 order-xs3
                  v-if="_.get(profile, 'ein', false)" class="pb-3">
            <b>EIN:</b> {{profile.ein}}
          </v-flex>
        </v-layout>
        <v-layout column v-if="shouldShowLoadChuteInfo">
          <div>
            <b v-if="_.get(loadingPlace, 'placeName')">{{_.get(loadingPlace, 'placeName')}}:</b>
          </div>
          <div>
            {{_.get(loadingPlace, 'formattedAddress')}}
          </div>
          <br/>
          <div>
            <b>Timezone:</b> {{_.get(loadingPlace, 'timezone')}}
          </div>
          <div>
            <b>Local Time:</b> {{locationLocalTime}}
          </div>
          <v-layout column v-if="loadingChute">
            <div>
              <b>Company instructions for {{$t('company-profile.load-chute')}} </b>
              <span v-if="_.get(loadingChute, 'label')">
             ({{loadingChute.label}})
            </span>:
            </div>
            <div>
              <span class="font-italic" v-if="loadingChute">{{loadingChute.instructions}}</span>
            </div>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import IconPdf from '@/components/icons/IconPDF';
import { LoadCompanyRole } from '@/types';
import * as Checks from '@/store/permissions';
import * as types from '@/store/mutationTypes';
import * as Loads from '@/types/models/load';

export default {
  name: 'CompanyProfileCard',
  components: {
    IconPdf,
  },
  props: {
    role: {
      type: String,
      default() {
        return '';
      },
    },
    load: {
      type: Object,
    },
    listing: {
      type: Object,
    },
    companyProfile: {
      type: Object,
    },
    companyId: {
      type: String,
    },
  },
  data: () => ({
    drawer: {
      open: null,
      mini: true,
      permanent: true,
    },
    profile: null,
    company: null,

    currentView: '',

    showLoadChuteInfo: false,
    showLoadContactInfo: false,
    showCompanyContactInfo: false,
    showCarrierDocumentation: false,
  }),
  filters: {
    gMapLink(googlePlaceId) {
      return `https://www.google.com/maps/place/?q=place_id:${googlePlaceId}`;
    },
  },
  computed: {
    ...mapState('applications', {
      appLoading: 'loading',
      companies: 'companies',
    }),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    _() {
      return _;
    },
    isProducer() {
      return LoadCompanyRole.Producer === this.role;
    },
    isCarrier() {
      return LoadCompanyRole.Carrier === this.role;
    },
    isOriginStockyard() {
      return LoadCompanyRole.OriginStockyard === this.role;
    },
    isDestinationStockyard() {
      return LoadCompanyRole.DestinationStockyard === this.role;
    },
    isStockyard() {
      return this.isOriginStockyard || this.isDestinationStockyard;
    },
    viewProfile() { // Company profile or pickup/dropoff company profile
      return this.companyProfile || this.profile;
    },
    shouldShowCarrierDocumentation() {
      return this.load &&
        this.isCarrier &&
        this.showCarrierDocumentation &&
        this.canViewCarrierDocumentation;
    },
    shouldShowLoadChuteInfo() {
      return this.isStockyard && this.showLoadChuteInfo;
    },
    canViewCarrierDocumentation() {
      if (this.listingCompany) {
        const producerAccount = this.findCompanyAccount()(this.listingCompany.id);
        return this.isCarrier &&
          (this.isLtnAdmin || Checks.accountHasOfficePermission(producerAccount));
      }
      return false;
    },
    locationLocalTime() {
      return this.loadingPlace ? moment().tz(_.get(this.loadingPlace, 'timezone')).format('HH:mm') : '';
    },
    listingCompany() {
      return _.get(this.loadDetails, 'listingCompany');
    },
    loadDetails() {
      if (this.load) {
        return _.get(this.load, 'tacticalInfo.loadDetails');
      }

      if (this.listing) {
        return this.listing;
      }

      return null;
    },
    truckingInfo() {
      return this.load ?
        _.get(Loads.carrierCompany(this.load), 'truckingInfo', {}) : null;
    },
    loadLocation() {
      let locationPath = '';
      let contextObject;
      if (this.load) {
        contextObject = this.load;
        locationPath = 'tacticalInfo.loadDetails.';
      } else if (this.listing) {
        contextObject = this.listing;
      } else {
        contextObject = {};
      }

      if (this.isOriginStockyard) {
        locationPath += 'pickupLocation';
      }
      if (this.isDestinationStockyard) {
        locationPath += 'dropoffLocation';
      }

      return _.get(contextObject, locationPath);
    },
    loadingPlace() {
      return _.get(this.loadLocation, 'googlePlace');
    },
    loadingChute() {
      return _.get(this.loadLocation, 'chute');
    },
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    async openFile(fileUrl) {
      this.$store.commit(`applications/${types.START_LOADING}`);
      const response = await API.application.getDocument({ url: fileUrl });
      const url = window.URL.createObjectURL(response);
      window.open(url);
      this.$store.commit(`applications/${types.END_LOADING}`);
    },
    toggleProfileData(showView) {
      this[this.currentView] = false;
      this.currentView = showView;
      this[this.currentView] = true;
      this.drawer.mini = true;
    },
    async loadProfiles() {
      if (this.isOriginStockyard && this.loadDetails.pickupCompany) {
        // Load pickup company profile
        this.company = this.loadDetails.pickupCompany;
      } else if (this.isDestinationStockyard && this.loadDetails.dropoffCompany) {
        this.company = this.loadDetails.dropoffCompany;
      }

      if (this.company || this.companyId) {
        const apiResponse = await API.company.byId({ id: this.companyId || this.company.id });
        this.profile = apiResponse.data;
      }
    },
  },
  created() {
    // show meaningful default info for the company role
    if (this.isStockyard) {
      this.toggleProfileData('showLoadChuteInfo');
    } else {
      this.toggleProfileData('showLoadContactInfo');
    }

    if (this.listing && this.load) {
      // eslint-disable-next-line
      console.error('Invalid use of this component: use either a load or a listing; not both');
    }

    if (this.listing && this.role === LoadCompanyRole.Carrier) {
      // eslint-disable-next-line
      console.error('Invalid use of this component; Carriers are never known on a listing');
    }

    if (!this.companyProfile) {
      this.loadProfiles();
    }

    if (this.companyId) {
      this.toggleProfileData('showCompanyContactInfo');
    }
  },
};
</script>

<style scoped>
  .custom-drawer {
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CompanyProfileCard.vue